export default __webpack_public_path__ + "static/media/slide4.942cdaad.jpg";